import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as env } from 'src/environments/environment';
import { Router } from '@angular/router';
import { Credentials } from '../../shared/models/credentials';
import { LocalStorageService } from '../../shared/services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private HTTPheaders;
  private options;

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly localStorageService: LocalStorageService,
  ) {
    this.HTTPheaders = {
      'Content-Type': 'application/json',
    };
    this.options = {
      headers: this.HTTPheaders,
    };
  }

  login(credentials: Credentials): Observable<object> {
    return this.http.post(env.baseUrl + 'Auth', credentials, this.options);
  }

  async checkToken(): Promise<boolean> {
    return !!this.localStorageService.getItem('token');
  }

  logout(): void {
    this.localStorageService.clear();
    this.router.navigate(['/auth']);
  }

  isLoggedIn(): boolean {
    return !!this.localStorageService.getItem('token');
  }

  getUser() {
    const data = this.localStorageService.getItem('currentUser');
    return data ? JSON.parse(data) : null;
  }

  getRole() {
    const user = this.getUser();
    return user ? user.role : null;
  }

  getRoleId() {
    const user = this.getUser();
    return user ? user.role?.id : null;
  }

  getInfoAccount(): Observable<Object> {
    return this.http.get(env.baseUrl + 'Auth', this.options);
  }

  updateUserAdmin(request: any): Observable<Object> {
    return this.http.post(env.baseUrl + 'update-profile', request, this.options);
  }

  changePassword(request: any): Observable<object> {
    return this.http.put(env.baseUrl + 'Auth/ChangePassword', request, this.options);
  }

  resetPassword(request: any): Observable<object> {
    return this.http.post(env.baseUrl + 'Auth/ResetPassword', request, this.options);
  }

  refreshToken(token: string): Observable<object> {
    return this.http.get(env.baseUrl + `Auth/RefreshToken?JwtToken=${token}`, this.options);
  }
}
